import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { LocalStorageService } from 'ng2-webstorage';

import { Base64 } from 'ng-jhipster';
import { API_SERVER, API_SERVER_VERSION } from '../../app.constants';
import {Router} from '@angular/router';

@Injectable()
export class AuthServerProvider {

    constructor(
        private http: Http,
        private base64: Base64,
        private $localStorage: LocalStorageService,
        private router: Router
    ) {}

    getToken() {
        return this.$localStorage.retrieve('authenticationToken');
    }

    login(credentials): Observable<any> {
        const data = 'username=' +  encodeURIComponent(credentials.username) + '&password=' +
            encodeURIComponent(credentials.password) + '&grant_type=password&scope=read%20write&' +
            'client_secret=gzt567!#Huvikvgz8uklgzuas3456dasd&client_id=marketmanagerbackoffice';
        const headers = new Headers ({
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json',
            'Authorization': 'Basic ' + this.base64.encode('marketmanagerbackoffice' + ':' + 'gzt567!#Huvikvgz8uklgzuas3456dasd')
        });

        return this.http.post(API_SERVER + 'oauth/token', data, {
            headers
        }).map(authSuccess.bind(this));

        function authSuccess(resp) {
            const response = resp.json();
            const expiredAt = new Date();
            expiredAt.setSeconds(expiredAt.getSeconds() + response.expires_in);
            response.expires_at = expiredAt.getTime();
            this.$localStorage.store('authenticationToken', response);
            return response;
        }
    }

    refresh(): Observable<any> {
      const data = 'grant_type=refresh_token&' +
        'client_secret=my-secret-token-to-change-in-production&client_id=marketmanagerapp' +
        '&refresh_token=' + this.getToken().refresh_token;
      const headers = new Headers ({
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': 'application/json',
        'Authorization': 'Basic ' + this.base64.encode('marketmanagerapp' + ':' + 'my-secret-token-to-change-in-production')
      });

      return this.http.post(API_SERVER + 'oauth/token', data, {
        headers
      }).map(authSuccess.bind(this));

      function authSuccess(resp) {
        const response = resp.json();
        const expiredAt = new Date();
        expiredAt.setSeconds(expiredAt.getSeconds() + response.expires_in);
        response.expires_at = expiredAt.getTime();
        this.$localStorage.store('authenticationToken', response);
        return response;
      }
    }

    logout(): Observable<any> {
        return new Observable(observer => {
            this.http.post(API_SERVER + 'api/' + API_SERVER_VERSION + '/logout', {});
            this.$localStorage.clear('authenticationToken');
            this.router.navigateByUrl('login');
            observer.complete();
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/auth/auth-oauth2.service.ts